import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierPerformanceIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 2H1C0.45 2 0 2.45 0 3V21C0 21.55 0.45 22 1 22H23C23.55 22 24 21.55 24 21V3C24 2.45 23.55 2 23 2ZM22 20H2V4H22V20Z"
        fill={color}
      />
      <path
        d="M4 13H6C6.34 13 6.67 12.82 6.85 12.53L8.4 10.04L12.1 17.45C12.42 18.14 13.48 18.19 13.85 17.52L16.56 13.01H19.99C21.29 13.03 21.29 10.99 19.99 11.01H15.99C15.64 11.01 15.31 11.19 15.13 11.5L13.07 14.94L9.38 7.57C9.06 6.88 8.03 6.84 7.64 7.49L5.43 11.02H3.98C2.68 11 2.68 13.04 3.98 13.02L4 13Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierPerformanceIcon.displayName = 'HierPerformanceIcon';
